<template>
  <v-btn
    class="first-draft-button"
    :variant="variant"
    rounded="lg"
    color="primary"
    :class="{ 'pa-0 pr-2 pl-2': small, small }"
    :disabled="disabled"
    :loading="loading"
    :height="small ? 24 : undefined"
    :size="small ? 'small' : undefined"
    :title="tooltip"
  >
    <FirstDraftStarsFilled
      v-if="variant === 'outlined' || variant === 'plain'"
      class="mr-1"
    />
    <FirstDraftStars
      v-else
      class="mr-1"
    />
    <slot />
  </v-btn>
</template>

<script>
import FirstDraftStarsFilledIcon from '@ui/components/firstDraft/FirstDraftStarsFilledIcon.vue';
import FirstDraftStars from '@ui/assets/icons/First_Draft_Stars.svg?component';

export default {
  name: 'FirstDraftButton',
  components: { FirstDraftStarsFilled: FirstDraftStarsFilledIcon, FirstDraftStars },
  props: {
    variant: { type: String, default: 'flat' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    tooltip: { type: String, default: 'Generate content with AI features' },
  },
};
</script>

<style scoped lang="less">
.first-draft-button {
  &:not(.v-btn--variant-plain) {
    background: linear-gradient(to right, #DB44FA, 50%, #4C61FF);
    border-color: #9452fc;
  }

  &.v-btn--variant-outlined {
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    border-color: @stroke-default;
  }

  &.small svg {
    height: 20px;
  }

  &:not(.v-btn--variant-outlined):not(.v-btn--variant-plain):hover {
    svg, svg:deep(path) {
      fill: @white !important;
    }
  }
}
</style>
